const readConnectionId = () => {
        const TIMELIMIT = 6 * 60 * 60 * 1000;
        const raw = localStorage.getItem("connectionId");
        if (!raw) return null;

        try {
            const { value, shop, createdAt, source, userId } = JSON.parse(raw);

            if (!value || !shop || !createdAt) {
                localStorage.removeItem("connectionId");
                return null;
            }

            if (Date.now() - createdAt > TIMELIMIT) {
                localStorage.removeItem("connectionId");
                return null;
            }

            return { value, shop, source, userId };
        } catch {
            localStorage.removeItem("connectionId");
            return null;
        }
    };

export default readConnectionId;

/*
 * Gone once it has been used or refused. It was only ever dropped on expiry
 * (6h), so a dead or already-used id was re-sent on every login and every
 * Dashboard mount — and followed whoever signed in next on this browser.
 */
export const clearConnectionId = () => {
    try { localStorage.removeItem("connectionId"); } catch (_) { /* storage blocked */ }
};
